// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader_loaderWrapper__L87tE"};